import React from "react";
import logoutIcon from "../../../assets/images/logout.svg";

interface LogoutButtonProps {
  onLogoutClick: () => void;
}

const LogoutButton: React.FC<LogoutButtonProps> = ({ onLogoutClick }) => {
  return (
    <button
      onClick={onLogoutClick}
      className="gap-1 justify-center items-center mt-4 text-sm font-semibold leading-loose text-rose-700 whitespace-nowrap min-h-[66px]"
    >
      <div className="flex gap-1 items-center self-stretch px-6 py-2 my-auto rounded-3xl border border-rose-700 border-solid">
        <img
          loading="lazy"
          src={logoutIcon}
          alt=""
          className="object-contain shrink-0 self-stretch my-auto aspect-square w-[21px]"
        />
        <span className="self-stretch my-auto">Logout</span>
      </div>
    </button>
  );
};

export default LogoutButton;
